import BaseApi from './BaseApi.js';

class LocationsApi extends BaseApi {
  static get endpoint() {
    return this.buildOrgEndpoint('/location');
  }

  static async getLocations() {
    return await this.get(this.endpoint);
  }

  static async getLocationById(locationId) {
    const endpoint = `${this.endpoint}/${locationId}`;
    return await this.get(endpoint);
  }

  static async addLocation(locationData) {
    return await this.post(this.endpoint, locationData);
  }

  static async updateLocation(locationId, locationData) {
    const endpoint = `${this.endpoint}/${locationId}`;
    return await this.put(endpoint, locationData);
  }

  static async deleteLocation(locationId) {
    const endpoint = `${this.endpoint}/${locationId}`;
    return await this.delete(endpoint);
  }

  static async getServices() {
    const endpoint = `${this.endpoint}/service`;
    return await this.get(endpoint);
  }

  static async getStates() {
    const endpoint = this.buildOrgEndpoint('/location/states');
    return await this.get(endpoint);
  }

  static async getStatesByCountry(countryId) {
    const endpoint = this.buildOrgEndpoint(`/location/states?country=${countryId}`);
    return await this.get(endpoint);
  }

  // Helper method to get initial data (locations, services only)
  // Countries, states, and timezones should be fetched separately using dedicated APIs
  static async getInitialData() {
    try {
      const [locationsResponse, servicesResponse] = await Promise.all([
        this.getLocations(),
        this.getServices()
      ]);

      return {
        data: {
          locations: locationsResponse.data,
          services: servicesResponse.data
        }
      };
    } catch (error) {
      console.error('Failed to load initial data:', error);
      throw error;
    }
  }
}

export default LocationsApi;